import * as tslib_1 from "tslib";
import getBlockSendersConfirmTitleAndSubtext from './getBlockSendersConfirmTitleAndSubtext';
import blockSenderService from '../../services/blockSenderService';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
/**
 * Shows the confirm dialog before sending out the block service call
 * @param mailboxes to block
 * @param blockActionCallback to be called upon sending out the service call
 */
export default function blockLastSendersHelper(mailboxes, blockActionCallback) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, title, subtext, confirmResponse;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!mailboxes) {
                        // Do nothing in case of invalid mailboxes,
                        // i.e mailboxes is null when user tries to block self
                        return [2 /*return*/];
                    }
                    _a = getBlockSendersConfirmTitleAndSubtext(mailboxes), title = _a[0], subtext = _a[1];
                    return [4 /*yield*/, confirm(title, subtext)];
                case 1:
                    confirmResponse = _b.sent();
                    if (confirmResponse !== DialogResponse.ok) {
                        return [2 /*return*/];
                    }
                    try {
                        blockSenderService(mailboxes);
                    }
                    catch (error) {
                        // VSO 19006: Handle service error caused by block
                    }
                    blockActionCallback();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=blockLastSendersHelper.js.map